import styled, { createGlobalStyle } from "styled-components";
import { Body1, Body2, Body3 } from '../style-comps/Common.styles';
import DatePicker from "react-datepicker";


export const PopupOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
`;

export const PopupContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 20px;
    z-index: 1000;
    border-radius: 8px;
    width: 60%;
    height: 80vh;            
    display: flex;
    flex-direction: column;
    overflow: visible;    /* ← hidden 改成 visible */

    @media (max-width: 768px) {
        width: 95%;
        padding: 16px;
        padding-bottom: 80px; 
        height: 85vh; 
        max-height: 85vh;
        overflow: visible;    /* ← 這裡也加 */
    }
`;


export const PopupTitle = styled.h3`
    margin: 0 0 10px 0;
    font-size: 18px;
`;

export const PopupText = styled.p`
    font-size: 14px;
    margin: 10px 0;
`;

export const PopupButton = styled.button`
    background-color: #61cbc9;
    color: #fff;
    border: none;
    padding: 0.625rem 1.25rem; 
    border-radius: 0.3125rem; 
    cursor: pointer;
    font-size: 1rem; 
    transition: background-color 0.3s ease;
    min-width: 100px;
    &:hover {
        background-color: rgba(97, 203, 201, 0.9);
    }

    &:focus {
        outline: 2px solid #fff; 
        outline-offset: 2px;
    }
    
    @media (max-width: 768px) {
        padding: 12px 24px; 
        font-size: 16px;
        min-width: 120px;
    }
`;

/* Tab Styles */
export const TabContainer = styled.div`
    width: 100%;
    position: relative;
    margin-top: 20px;
    padding-bottom: 100px;
    flex: 1;                     
    overflow: visible;
    overflow-y: auto;
     
    @media (max-width: 768px) {
        width: 100%;
        padding-bottom: 140px; 
        overflow-y: auto;
        flex: 1; 
        max-height: none; 
    }
`;

export const TabHeader = styled.div`
    display: flex;
    align-items: flex-end;
    
`;

export const TabContent = styled.div`
  border-top: 1px solid #ECECEC;
  padding: 16px;
  display: flex;
  gap: 55px;
  overflow: visible;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
    padding: 16px;
    padding-bottom: 20px;
    overflow: visible;
  }
`;


export const TabLeft = styled.div`
    flex: 0 0 45%;

    @media (max-width: 768px) {
        flex: none; 
        width: 100%;
        order: 2; 
    }
`;

export const TabRight = styled.div`
    flex: 0 0 50%;

    @media (max-width: 768px) {
        flex: none; 
        width: 100%;
        order: 1; 
        margin-bottom: 20px; 
    }
`;

export const TabNameTitle = styled.div`
    margin-top:30px;
`;

export const TabBody1 = styled(Body1)`
    padding-bottom:8px;
`

export const TabBody2 = styled(Body2)`

`

export const TabBody3 = styled(Body3)`
    color:#333;
`

export const CustomDatePicker = styled(DatePicker)`
    border: 1px solid #fff;
`;

export const ListingInfo = styled.div`
    border: 1px solid #ECECEC;
    border-radius: 8px;
    padding: 16px;
    
    @media (max-width: 768px) {
        margin-top: 0;
        margin-bottom: 0; 
        width: 100%;
    }
`;

export const ListingInfoTitle = styled.div`

`;

export const ListingInfoImg = styled.img`
    width:100px;
    height:60px;
    background-color:#000;
    border-radius: 8px; 
`;

export const ListingInfoWrap = styled.div`
   display:flex;
   gap:16px;
   padding-bottom:6px;
`;

export const ListingInfoWrap2 = styled.div`
   display:flex;
   flex-direction: row;
   gap:4px;
   
`;

export const RowWrap = styled.div`
   display:flex;
   flex-direction: row;
   gap:8px;
   margin-top:20px;
   
`;

export const ListingInfoTag = styled.button`
   background-color: #61cbc9;
   color: #fff;
   border-radius: 16px;
   border: 1px solid transparent;
   padding: 2px 16px;
   cursor: pointer;
   

   &:hover {
       background-color: #61cbc9; 
       border-color: #61cbc9; 
   }
`;

export const HolidayNote = styled(Body1)`
    width: 100%;
    min-height: 120px;
    padding: 12px;
    color: #333;
    border: 1px solid #61cbc9;
    border-radius: 8px;
    background-color: #fff;
    resize: vertical;
    margin-top:20px;
   
`;


export const ButtonWrap = styled.div`
    position: absolute;
    right: 16px;
    bottom: 16px;
    display: flex;
    gap: 16px;
    z-index: 10;

    @media (max-width: 768px) {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        transform: none; 
        width: 100%;
        justify-content: center;
        background-color: white;
        padding: 16px 20px;
        box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
        border-radius: 0; 
        z-index: 9999; 
    }
`;

export const Radio = styled.input.attrs({ type: "radio" })`
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #61cbc9;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;

    &:checked {
        background-color: #61cbc9;
        border-color: #61cbc9;
    }

    &:checked::after {
        content: "";
        width: 10px;
        height: 10px;
        background: white;
        border-radius: 50%;
        display: block;
    }
`;




export const TabButton = styled.button`
    padding: ${(props) => (props.active ? '10px 15px' : '6px 15px')};
    font-size: ${(props) => (props.active ? '18px' : '14px')};
    background: ${(props) =>
        props.disabled
            ? '#e0e0e0'  /* 禁用時的灰色背景 */
            : props.active
                ? '#fff'
                : 'rgba(97, 203, 201, 0.5)'
    };
    color: ${(props) =>
        props.disabled
            ? '#999'  /*  禁用時的灰色文字 */
            : props.active
                ? '#61CBC9'
                : '#fff'
    };
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 0.1px solid #ECECEC;
    border-bottom: none;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};  
    height: ${(props) => (props.active ? '45px' : '35px')};
    font-weight: bold;
    opacity: ${(props) => (props.disabled ? '0.6' : '1')};  
    pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};  
    transition: background-color 0.3s ease, color 0.3s ease, height 0.3s ease, font-size 0.3s ease, padding 0.3s ease;

    &:hover {
        background-color: ${(props) =>
        props.disabled
            ? '#e0e0e0'  /* 禁用時 hover 不變 */
            : props.active
                ? '#fff'
                : 'rgba(97, 203, 201, 0.7)'  /* 非禁用時稍微變深 */
    };
    }
`;

export const DateRangeContainer = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #61cbc9;
    border-radius: 8px;
    padding: 5px 10px;
    margin-top: 10px;
    overflow: visible;

    @media (max-width: 768px) {
        padding: 5px 6px;
        overflow: visible;
    }
`;

export const DateInput = styled.div`
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #333;
    min-width: 0;
    overflow: visible;

    input {
        width: 100%;
        font-size: 13px;
    }

    @media (max-width: 768px) {
        font-size: 12px;

        input {
            font-size: 11px;
            width: 100%;
        }
    }
`;

export const DatePickerGlobalStyle = createGlobalStyle`
  .react-datepicker-popper {
    z-index: 10000 !important;
  }

  .kozy-datepicker-popper {
    z-index: 10000 !important;
  }

  .react-datepicker {
    z-index: 10000 !important;
  }
`;

export const Arrow = styled.span`
    font-size: 16px;
    color: #61cbc9;
    margin: 0 5px;
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
`;

export const Checkbox = styled.input`
    appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #61cbc9;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:checked {
        background-color: #61cbc9;
    }

    &:checked::after {
        content: "✔";
        color: white;
        font-size: 12px;
    }
`;

export const Label = styled.label`
    font-size: 14px;
    color: #333;
`;

export const StyledTextArea = styled.textarea`
    width: 100%;
    min-height: 120px;
    padding: 12px;
    font-size: 14px;
    color: #333;
    border: 1px solid #61cbc9;
    border-radius: 8px;
    background-color: #fff;
    resize: vertical;

    &:focus {
        outline: none;
        border-color: #61cbc9;
        box-shadow: 0 0 4px rgba(97, 203, 201, 0.5);
    }

    &::placeholder {
        color: #aaa;
        font-style: italic;
    }
`;

export const WeekdayCheckboxContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* Space between items */
    margin-top: 15px;
`;

export const WeekdayCheckboxItem = styled.div`
    display: flex;
    align-items: center;
    width: calc(50% - 10px); 
    margin-bottom: 10px; 
`;